var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transactionList"},_vm._l((_vm.transactionList),function(t,index){return _c('TransactionEntry',{key:index,staticClass:"tEntry",attrs:{"entry":t,"prev":_vm.transactionList[index-1]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }